(() => {
  const VTO_EMAIL_STORAGE_KEY = '_vtoUserEmail';
  const VTO_GENERIC_EVENT_NAME = 'vto:event';

  const VTO_API_ENDPOINT =
    'https://api.zerezes.net/shopify/api/vto-session-event';
  const VTO_API_KEY = 'Key 9yb3cw7n2m5qtx8akd1vuh6rz4ep0fsg';

  // ---------------------------------------------------------------------------
  // Catálogo de tipos de evento
  // ---------------------------------------------------------------------------

  /**
   * @readonly
   * @enum {string}
   */
  const VTO_EVENT_TYPES = Object.freeze({
    TRYON_CTA_CLICKED:        'tryon_cta_clicked',
    TRYON_MODAL_OPENED:       'tryon_modal_opened',
    TRYON_LOGIN_PROMPT_SHOWN: 'tryon_login_prompt_shown',
    TRYON_EMAIL_DISMISSED:    'tryon_email_dismissed',
    TRYON_EMAIL_SUBMITTED:         'tryon_email_submitted',
    TRYON_PHOTO_METHOD_SELECTED:   'tryon_photo_method_selected',
    TRYON_PHOTO_UPLOADED:          'tryon_photo_uploaded',
    TRYON_GENERATION_COMPLETED:    'tryon_generation_completed',
    TRYON_GENERATION_FAILED:       'tryon_generation_failed',
    TRYON_MODAL_CLOSED:            'tryon_modal_closed',
    TRYON_RETURNED_CLOSED:         'tryon_returned_closed',
    TRYON_ADD_TO_CART:      'tryon_add_to_cart',
  });

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  /**
   * @param {string | undefined} value
   * @returns {string}
   */
  function normalizeString(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  /**
   * Persiste o e-mail em localStorage para não pedir novamente.
   *
   * @param {string} email
   */
  function persistVtoEmail(email) {
    if (!email) return;
    try {
      localStorage.setItem(VTO_EMAIL_STORAGE_KEY, email);
    } catch {
      // Ignora erros de storage (modo privado, cota, etc.)
    }
  }

  // ---------------------------------------------------------------------------
  // API
  // ---------------------------------------------------------------------------

  /**
   * Envia o evento para a API zerezes.
   *
   * @param {{ email: string; eventName: string; shopifyVariantId: string }} detail
   */
  function sendVtoEventToApi(detail) {
    const variantIdNum = Number(detail.shopifyVariantId);

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', VTO_API_KEY);

    fetch(VTO_API_ENDPOINT, {
      method: 'POST',
      headers,
      redirect: 'follow',
      body: JSON.stringify({
        email:            detail.email,
        eventName:        detail.eventName,
        shopifyVariantId: Number.isFinite(variantIdNum) ? variantIdNum : null,
      }),
    }).catch(err => {
      console.warn('[vto-events] API error:', err);
    });
  }

  // ---------------------------------------------------------------------------
  // Dispatcher unificado
  // ---------------------------------------------------------------------------

  /**
   * Dispatcher unificado. Persiste o e-mail (se presente) e emite o custom
   * event `vto:event` no document com os campos no formato esperado pela API.
   *
   * @param {{ email?: string; variantId: string; event: string }} payload
   */
  function dispatchVtoEvent(payload) {
    const detail = {
      email:            normalizeString(payload.email),
      eventName:        normalizeString(payload.event),
      shopifyVariantId: normalizeString(payload.variantId),
    };

    if (detail.email) persistVtoEmail(detail.email);

    document.dispatchEvent(new CustomEvent(VTO_GENERIC_EVENT_NAME, { detail }));
  }

  window.dispatchVtoEvent        = dispatchVtoEvent;
  window.VTO_EVENT_TYPES         = VTO_EVENT_TYPES;

  // ---------------------------------------------------------------------------
  // Listener
  // ---------------------------------------------------------------------------

  document.addEventListener(VTO_GENERIC_EVENT_NAME, event => {
    const detail = /** @type {CustomEvent} */ (event).detail || {};
    sendVtoEventToApi(detail);
  });
})();
